const isStringArabic = stringToBeTested => {
	var arabic = /[\u0600-\u06FF]/;
	return arabic.test(stringToBeTested);
};

export default isStringArabic;



// WEBPACK FOOTER //
// ./src/store/isStringArabic.js